// @ts-nocheck
/* eslint-disable */

  /**
  * Do not change! File was auto generate. 
  *
  */
  
import React from 'react';

import { ReactComponent as LockComponent} from './Lock.svg';

import Icon, { TIconProps } from '../Icon';

export const IconLock = React.forwardRef<any, TIconProps>((props, ref) => (
  <Icon
    ref={ref}
    {...props}
  >
    <LockComponent/>
  </Icon>
));
